<template>
    <div v-if="serviceProducts.length > 2">
        <!-- <AllParkingLotsSection v-editable="blok" :products="filteredProducts" :blok="blok" /> -->
        <AprProductsCarousel :blok="blok" :products="filteredProducts" :section-config="sectionConfig" />
    </div>
</template>

<script setup lang="ts">
// import AllParkingLotsSection from '../components/sections/parking/AllParkingLotsSection.vue';
import AprProductsCarousel from '~/components/sections/AprProductsCarousel.vue';
import type { IAllPortParkingConfig } from '@nuxt-monorepo/ui/types/components/Parking';
import type { IProductsSectionConfig } from '~/../types/ProductsCarousel';

import type { IAirportProducts, IParkingProduct } from '@nuxt-monorepo/ui/types';
const { products, blok } = defineProps<{
    blok: IAllPortParkingConfig;
    products: IAirportProducts;
}>();
const serviceProducts = computed(() => {
    return Array.isArray(products.parking)
        ? products.parking.filter((product: IParkingProduct) => {
              return product.service === true;
          })
        : [];
});

const filteredProducts = computed(() => {
    return [...serviceProducts.value.slice(2), ...serviceProducts.value.slice(0, 2)];
});

const sectionConfig: IProductsSectionConfig = {
    title: 'title',
    subtitle: {
        subtitleName: 'subtitle',
        subtitleType: 'RichText',
    },
    cardType: 'ParkingLotProductCard',
};
</script>
